import { APICfg } from 'services/api/api'
import { LocationArrangementName } from 'types/form'
import { ProductPackage, ProductPreset } from './common'

export type APILocationProductPreset = ProductPreset & {
  arrangement: LocationArrangementName
}

export type LocationPreset = ProductPreset & {
  arrangement?: LocationArrangementName
}

export type APILocationPackage = ProductPackage<APILocationProductPreset>

export type LocationPackage = ProductPackage<LocationPreset>

const apiCfg: APICfg = {
  endpoint: 'locationPackage',
  parse: (res: APILocationPackage): APILocationPackage => res,
  write: async (req: APILocationPackage): Promise<APILocationPackage> => req,
}

export default apiCfg
